import { TagProps, Tag, Flex, StackProps } from "@chakra-ui/react";
import React from "react";

export function PageHeadingTag(props: TagProps) {
  return (
    <Tag
      size="lg"
      variant="outline"
      color="gray.800"
      borderRadius="xl"
      {...props}
    />
  );
}

export function PageHeadingTagContainer(props: StackProps) {
  return (
    <Flex
      alignItems="center"
      wrap="wrap"
      gridGap={{ base: 2, sm: 6 }}
      {...props}
    />
  );
}
